export default __webpack_public_path__ + "static/media/AELIN.2ecba7f3.webp";